<script>
import baseList from "@/views/components/base/baseList.vue";
export default {
  extends: baseList,
  components: {
    Image,
  },
  data() {
    return {
      labeltype:"标签管理",
      table: {
        mname: "labelType",
        key: "id",
        url: {
          del: "/admin/labelType",
        },
        output: false,
        order:'id',
        qrCode: "qrCode",
      },
      actions: [
        {
          label: "新增标签",
          icon: "md-add",
          onClick: this.toAdd,
          auth: "/admin/labelType/add",
          type: "info",
        },
      ],
      menus: [
        // { label: "商品管理", name: "commodity_list", auth: "/admin/commodity/list"},
        // { label: "分类管理", name: "commodityType_list", auth: "/admin/commodityType/list"},
        // { label: "标签管理", name: "labelType_list", auth: "/admin/labelType/list"},
        // { label: "日志管理", name: "logType_list", auth: "/admin/logType/list"},
        // { label: "物流管理", name: "logisticsType_list", auth: "/admin/logisticsType/list"},
        // { label: "订单管理", name: "ordersType_list", auth: "/admin/ordersType/list"},
      ],
      query: {
        //state: 2,
      },
      filters: [
      {label: '标签名称', name: 'labelName', value: '', type: 'input'},
      ],
      tableCols: [
        // {
        //   type: "selection",
        //   width: 60,
        // },
        // {
        //   title: "ID",
        //   key: "id",
        //   minWidth: 120,
        //   align: "left",
        // },
        // {
        //   title: "客户ID",
        //   key: "id",
        //   minWidth: 160,
        //   align: "left",
        // },
        {
          title: "标签名称",
          key: "labelName",
          minWidth: 100,

          align: "center",
          // render: (h, params) => {
          //   const row = params.row;
          //   const text =
          //       row.id == 1
          //           ? "商品管理"
          //           : row.id == 2
          //               ? "分类管理"
          //               : "";
          //   return h(
          //       "div",text
          //   );
          // },
        },
        {
          title: "标签详情",
          key: "labelDetail",
          minWidth: 350,

          align: "left",
          // render:()=>{
          //   return <p style="margin:15px;padding:15px">此分类涵盖了商品上传，商品名称编辑，商品价格和商品进货价调整，商品详细页上传，订单管理，订单发货管理</p>
          // }
        },
        {
          title: "分类创建人",
          key: "createBy",
          minWidth: 160,

          align:"center",
          // render:()=>{
          //   return <p>张三</p>
          // }
        },
        {
          title: "分类创建时间",
          key: "createTime",
          minWidth: 160,

          align: "center",
          // render:()=>{
          //   return <p>2022.09.15  18.00</p>
          // }
        },
        {
          title: "操作",
          align: "center",
          width: 260,

          key: "handle",
          handle: [
            "edit",
            "delete"
          ],
          auth: {
            edit: "/admin/labelType/edit",
            del: "/admin/labelType",
          }
          // render:()=>{
          //     return (            
          //       <Space direction="vertical">
          //         <Space wrap>
          //             <Button>编辑</Button>
          //             <Button type="error" style="margin-left:10px">删除</Button>
          //         </Space>
          //     </Space>
          //     )
          // }
        },
      ],
    };
  },
  created() {
  },
  methods: {
    toAdd() {
      $utils.url.push({ name: "labelType_add", query: { action: "add" } });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "labelType_edit",
        query: { action: "edit", kv: currentRow.id },
      });
    },
  },
};
</script>

